export default __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-5495789.b6093065.mp4";